import { LOGIN_REDIRECT_KEY } from 'constants/app';

export default function readLoginRedirect() {
  return localStorage.getItem(LOGIN_REDIRECT_KEY);
}
